module.exports = __webpack_public_path__ + "img/wj_wsxx2.67eb6d2e.png";